<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('material-category-manage')" v-if="permissionCodes.indexOf('036001000') !== -1">
        <i class="el-icon-damai-ic_wuzileimu"></i>
        <span slot="title">物资类目</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('material-manage')" v-if="permissionCodes.indexOf('036010000') !== -1">
        <i class="el-icon-damai-ic_wuziguanli"></i>
        <span slot="title">物资管理</span>
      </el-menu-item>
      <el-submenu index="2" v-if="permissionCodes.indexOf('036002000') !== -1 || permissionCodes.indexOf('036003000') !== -1 || permissionCodes.indexOf('036004000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_churukuguanli"></i>
          <span>出入库管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('warehousing-management')" v-if="permissionCodes.indexOf('036002000') !== -1">入库管理</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('material-requisition')" v-if="permissionCodes.indexOf('036003000') !== -1">物资领用</el-menu-item>
          <el-menu-item index="2-3" @click="toNewRouter('inventory-statistics')" v-if="permissionCodes.indexOf('036004000') !== -1">库存统计</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="3" v-if="permissionCodes.indexOf('036005000') !== -1 || permissionCodes.indexOf('036011000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_wuzipandian"></i>
          <span>物资盘点</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1" @click="toNewRouter('material-inventory')" v-if="permissionCodes.indexOf('036005000') !== -1">领用盘点</el-menu-item>
          <el-menu-item index="3-2" @click="toNewRouter('consuming-inventory')" v-if="permissionCodes.indexOf('036011000') !== -1">库存盘点</el-menu-item>
          <!-- <el-menu-item index="2-3" @click="toNewRouter('inventory-statistics')" v-if="permissionCodes.indexOf('036004000') !== -1">库存统计</el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="7" v-if="permissionCodes.indexOf('036007000') !== -1 || permissionCodes.indexOf('036013000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_pandianbaobiao"></i>
          <span>盘点报表</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="7-1" @click="toNewRouter('collecting-inventory-report')" v-if="permissionCodes.indexOf('036007000') !== -1">领用盘点报表</el-menu-item>
          <el-menu-item index="7-2" @click="toNewRouter('count-inventory-report')" v-if="permissionCodes.indexOf('036013000') !== -1">库存盘点报表</el-menu-item>
          <!-- <el-menu-item index="2-3" @click="toNewRouter('inventory-statistics')" v-if="permissionCodes.indexOf('036004000') !== -1">库存统计</el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>
      <!-- <el-menu-item index="3" @click="toNewRouter('material-inventory')" v-if="permissionCodes.indexOf('036005000') !== -1">
        <i class="el-icon-damai-ic_wuzipandian"></i>
        <span slot="title">物资盘点</span>
      </el-menu-item> -->
      <el-menu-item index="4" @click="toNewRouter('configuration-management')" v-if="permissionCodes.indexOf('036008000') !== -1">
        <i class="el-icon-damai-ic_peizhiguanli"></i>
        <span slot="title">配置管理</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('material-log')" v-if="permissionCodes.indexOf('036009000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
     </el-menu-item>
      <!--
      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: [
    "material-category-manage",
    "material-category-add",
    "material-category-modify"
  ],
  "2-1": [
    "warehousing-management",
    "warehousing-management-add",
    "warehousing-management-modify"
  ],
  "2-2": [
    "material-requisition",
    "material-requisition-add",
    "material-requisition-modify"
  ],
  "2-3": ["inventory-statistics"],
  "3-1": [
    "material-inventory",
    "material-inventory-add",
    "material-inventory-modify",
    "inventory-list",
    "inventory-report"
  ],
  "3-2": [
    "consuming-inventory",
    "consuming-inventory-add",
    "consuming-inventory-modify",
    "stock-inventory-list",
    "stock-inventory-report"
  ],
  4: [
    "configuration-management",
    "configuration-management-add",
    "configuration-management-modify"
  ],
  5: ["material-log"],
  6: ["material-manage"],
  "7-1": ["collecting-inventory-report"],
  "7-2": ["count-inventory-report"]
});

export default {
  name: "material-management-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialManagementNav.vue